import { render, staticRenderFns } from "./IndicatorBoxes.vue?vue&type=template&id=f474a04a&scoped=true"
import script from "./IndicatorBoxes.vue?vue&type=script&lang=js"
export * from "./IndicatorBoxes.vue?vue&type=script&lang=js"
import style0 from "./IndicatorBoxes.vue?vue&type=style&index=0&id=f474a04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f474a04a",
  null
  
)

export default component.exports